// Copyright (c) 2019 Deere & Company

const PartGroupTableColumnDefinitions = [
    {
        field: 'partGroupName',
        headerName: 'Part Group',
        sortable: true,
        filter: true,
        resizable: true,
    },
    {
        field: 'partGroupDescription',
        headerName: 'Part Group Description',
        sortable: true,
        filter: true,
        resizable: true,
    },
    {
        field: 'partNumber',
        headerName: 'Corrected Part Number',
        sortable: true,
        filter: true,
        resizable: true,
    },
    {
        field: 'partNumberDescription',
        headerName: 'Corrected Part Description',
        sortable: true,
        filter: true,
        resizable: true,
    },
    {
        field: 'productSeriesName',
        headerName: 'Product Series',
        sortable: true,
        filter: true,
        resizable: true,
    },
];
export default PartGroupTableColumnDefinitions;
